var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSelfieCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 300,
    viewBox: "0 0 239 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238 0.5H1V299.5H238V0.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 1V299H1.5V1H237.5ZM238.5 0H0.5V300H238.5V0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.97 187.69H149.99V163.64C154.8 160.66 159.16 157.04 163.07 152.83C172.69 142.32 185.44 116.78 179.29 100.56C192.67 80.73 183.2 75.17 182.9 58.32C182.6 47.21 178.09 40.76 154.5 39.56C122.95 37.73 133.77 33.38 110.47 27.37C54.73 12.94 48.13 84.78 58.94 101.3C52.79 122.47 71.13 152.82 88.25 163.63V187.68H75.01C51.14 187.68 31.6 207.06 31.6 231.11V270.18C31.6 272.57 33.55 274.52 35.97 274.52H203.02C205.41 274.52 207.39 272.58 207.39 270.18V231.11C207.39 207.06 188 187.68 163.96 187.68L163.97 187.69ZM67.37 57.28C73.67 39.72 86.9 30.25 108.38 35.8C129.71 41.36 120.71 46.32 154.05 48.11C154.74 48.15 155.37 48.2 156.01 48.26C173.88 49.6 174.03 53.41 174.18 58.62C174.46 74.28 180.78 78.57 175.65 89.49C175.65 89.53 175.67 89.55 175.67 89.6C175.37 90.21 175.03 90.82 174.63 91.49C174.63 91.49 174.63 91.4933 174.63 91.5C174.5 91.73 174.36 91.95 174.22 92.19C173.96 92.59 173.7 93.02 173.43 93.49C165.76 87.93 155.09 87.19 146.4 87.19C137.71 87.19 113.78 89.91 108.38 86.44C88.25 74.14 78.63 74.88 64.65 92.45C62.86 85.25 62.26 71.12 67.37 57.29V57.28ZM67.67 102.5C75.94 91.69 80.75 86.73 86.45 86.73C90.5 86.73 95.77 89 103.72 93.96C117.7 102.51 157.66 88.38 170.72 102.51C175.97 113.32 165.91 136.77 156.61 146.99C140.52 164.58 114.67 168.76 94.09 157.05C79.37 148.63 61.49 119.51 67.66 102.51L67.67 102.5ZM141.28 168V190.11L119.03 211.73L96.96 190.11V168C111.24 173.71 127.01 173.71 141.28 168ZM198.67 265.83H170.27V242.38C170.27 236.67 161.57 236.67 161.57 242.38V265.83H77.42V242.38C77.42 236.67 68.7 236.67 68.7 242.38V265.83H40.32V231.12C40.32 211.88 55.94 196.41 75 196.41H90.8L116.04 221.05C116.93 221.8 117.98 222.25 119.02 222.25C120.22 222.25 121.29 221.8 122.04 221.05L147.28 196.41H163.95C183.18 196.41 198.65 211.88 198.65 231.12V265.83H198.67Z",
    fill: "#142030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.22 196.41C154.5 214.6 142.34 231.87 126.87 247.49C119.95 254.24 112.89 260.27 105.54 265.83H77.43V242.38C77.43 236.67 68.71 236.67 68.71 242.38V265.83H40.33V231.12C40.33 211.88 55.95 196.41 75.01 196.41H90.81L116.05 221.05C116.94 221.8 117.99 222.25 119.03 222.25C120.23 222.25 121.3 221.8 122.05 221.05L147.29 196.41H163.21H163.22Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.28 168V190.11L119.03 211.73L96.96 190.11V168C111.24 173.71 127.01 173.71 141.28 168Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.61 146.98C140.52 164.57 114.67 168.75 94.09 157.04C79.37 148.62 61.49 119.5 67.66 102.5C75.93 91.69 80.74 86.73 86.44 86.73C90.49 86.73 95.76 89 103.71 93.96C117.69 102.51 157.65 88.38 170.71 102.51C175.96 113.32 165.9 136.77 156.6 146.99L156.61 146.98Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.65 89.49C175.35 90.12 175.02 90.79 174.63 91.49C174.63 91.49 174.63 91.4933 174.63 91.5C174.5 91.73 174.36 91.95 174.22 92.19C173.96 92.59 173.7 93.02 173.43 93.49C165.76 87.93 155.09 87.19 146.4 87.19C137.71 87.19 113.78 89.91 108.38 86.44C88.25 74.14 78.63 74.88 64.65 92.45C62.86 85.25 62.26 71.12 67.37 57.29C73.67 39.73 86.9 30.26 108.38 35.81C129.71 41.37 120.71 46.33 154.05 48.12C154.8 48.27 155.39 48.27 156.01 48.27C165.14 60.72 171.61 74.66 175.65 89.5V89.49Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.01 48.26C155.39 48.26 154.8 48.26 154.05 48.11C154.74 48.15 155.37 48.2 156.01 48.26Z",
    fill: "#142030"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.67 89.59C175.37 90.2 175.03 90.81 174.63 91.48C175.02 90.78 175.35 90.12 175.65 89.48C175.65 89.52 175.67 89.54 175.67 89.59Z",
    fill: "#142030"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.01 48.26C155.39 48.26 154.8 48.26 154.05 48.11C154.74 48.15 155.37 48.2 156.01 48.26Z",
    fill: "#86a3b3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.65 89.49C171.61 74.65 165.14 60.72 156.01 48.26C173.88 49.6 174.03 53.41 174.18 58.62C174.46 74.28 180.78 78.57 175.65 89.49Z",
    fill: "#86a3b3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.67 231.12V265.83H170.27V242.38C170.27 236.67 161.57 236.67 161.57 242.38V265.83H105.53C112.88 260.27 119.94 254.25 126.86 247.49C142.33 231.87 154.49 214.59 163.21 196.41H163.96C183.19 196.41 198.66 211.88 198.66 231.12H198.67Z",
    fill: "#86a3b3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.67 89.59C175.37 90.2 175.03 90.81 174.63 91.48C175.02 90.78 175.35 90.12 175.65 89.48C175.65 89.52 175.67 89.54 175.67 89.59Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelfieCard);
export default __webpack_public_path__ + "static/media/ic-selfie-card.b2952ab00b6f9ae2a37a8cc9ab004820.svg";
export { ForwardRef as ReactComponent };